import { render, staticRenderFns } from "./admin-table-pagination.vue?vue&type=template&id=5b20c9a9&lang=pug&"
import script from "./admin-table-pagination.vue?vue&type=script&lang=js&"
export * from "./admin-table-pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports